// extracted by mini-css-extract-plugin
export var audioPlayer = "_ty-0";